import React from 'react'
import Trackingorder from '../Components/OrderDetails/Trackingorder';
import Breadcrumb from '../Components/Breadcrumb';

import { useEffect } from 'react';
function Trackingorderpage() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
       <Breadcrumb title_1="Your Account" title_2="Orders Details" title_3="Orders List"/>
       <Trackingorder />
    </>
  )
}

export default Trackingorderpage
